export default __webpack_public_path__ + "static/hhc-blog-3-91afa5c816cbd627bb0e182e8fec5949.png";